import React from "react"
  import {
    Container,
    Col,
    Row } from 'reactstrap';
    import logobottom from './images/logobottom.png';

    function Footer(){
          return (
            <Container fluid className="footer">
              <Row className="text-center">
                <Col>
                  <a href="https://aljazeera.com" target="_blank" rel="noopener noreferrer">
                    <img alt="Al Jazeera" width="257px" height="auto" src={logobottom}/>
                  </a>
                  <br/>
                  <br/>
                  <p>© 2020 Al Jazeera Media Network.</p>
                  </Col>
                  </Row>
                  
                  <Row className="justify-content-center align-items-center">
              <Col lg="6" md="8" xs="12" className="text-center credits">
                  <p>Produced by: <a href="https://twitter.com/haddadme" target="_blank" rel="noopener noreferrer">Mohammed Haddad</a> and <a href="https://twitter.com/aliachughtai" target="_blank" rel="noopener noreferrer">Alia Chughtai</a> for <a href="https://twitter.com/AJLabs" target="_blank" rel="noopener noreferrer">@AJLabs</a></p>
                </Col>
              </Row>
            </Container> 
          )
        }

export default Footer